<div mat-dialog-title></div>
<div class="m-2">
  <h2 class="ap-blue">{{ 'ml_144073' | translate }} {{ 'ml_143925' | translate }}</h2>

  <div mat-dialog-content class="m-0">
    <form [formGroup]="editForm" ngxsForm="{{formPath}}" [ngxsFormDebounce]="500" [ngxsFormClearOnDestroy]="true">
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144113' | translate}}</mat-label>
            <mat-select formControlName="terminal_Id" [disabled]="processing$ | async" (selectionChange)="onTerminalSelectionChanged($event)">
              @for (item of terminalSelectItems$ | async; track $index) {
              <mat-option [value]="item.value">
                {{item.label}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          {{('ml_144070' | translate) + ": " + (selectedBusinessType$ | async)}}
        </div>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="row m-0 p-2 justify-content-end">
    <spinner-button class="me-3 col-auto" [refreshState$]="processing$" [disabled]="editForm.invalid" label="{{ 'ml_143934' | translate }}" refreshLabel="{{ 'ml_143923' | translate }}"
      (clicked)="onOkClick()">
    </spinner-button>
    <button (click)="onCancelClick()" class="button--default button-back col-auto attachment-select">{{ 'ml_143935' | translate }}</button>
  </div>
</div>
